import React from 'react';
import './PlaylistsLoading.css';

export const PlaylistsLoading = () => {
    return (
        <div id="pageContainer">
            <div id="pageContent">
                <div className="loadingPlaylistTabs">
                </div>
                <div className="pageContentSegment loading">
                </div>
            </div>
        </div>
    )
}

export default PlaylistsLoading;